import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    canActivate: [guestGuard]
  },
  {
    path: 'documentation',
    loadComponent: () =>
      import('./pages/documentation/documentation').then((m) => m.Documentation),
    canActivate: [authGuard]
  },
  {
    path: 'catalog',
    loadComponent: () => import('./pages/catalog-page/catalog-page').then((m) => m.CatalogPage),
    canActivate: [authGuard]
  },
  {
    path: 'catalog/:name',
    loadComponent: () =>
      import('./pages/plugin-detail-page/plugin-detail-page').then((m) => m.PluginDetailPage),
    canActivate: [authGuard]
  },
  { path: '', pathMatch: 'full', redirectTo: 'catalog' },
  { path: '**', redirectTo: 'catalog' }
];
